import { useIsTablet } from '@hooks/use-media-query'
import { ArticleGenerator } from '@ui/article/ArticleGenerator'

import { config, mobileEmailFormProps, mobileHeaderProps } from './config'

const { headerProps, emailFormProps } = config

export function Medtech2024TrendsInsights() {
  const isTablet = useIsTablet()

  const configData = isTablet
    ? {
        ...config,
        emailFormProps: { ...emailFormProps, ...mobileEmailFormProps },
        headerProps: { ...headerProps, ...mobileHeaderProps },
      }
    : config

  return <ArticleGenerator config={configData} />
}
